module.exports = __webpack_public_path__ + "static/media/caret-up.0a23ebca.svg";